// src/components/TimeSlotWrapperWithContextMenu.js
import React from 'react';

const TimeSlotWrapperWithContextMenu = ({ children, value }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const copied = localStorage.getItem('copiedShift');

    if (copied) {
      try {
        const parsed = JSON.parse(copied);
        if (parsed?.start && parsed?.end) {
          window.dispatchEvent(
            new CustomEvent('calendar-empty-slot-left-click', {
              detail: {
                date: value,
                coords: {
                  x: e.clientX,
                  y: e.clientY,
                },
              },
            })
          );
          return;
        }
      } catch { }
    }

    // Si no hay shift copiado, despacha un evento para abrir el overlay normal
    window.dispatchEvent(
      new CustomEvent('calendar-create-new-shift', {
        detail: { date: value },
      })
    );
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div
        onClick={handleClick}
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          pointerEvents: 'auto',
        }}
      />
      <div style={{ position: 'relative', zIndex: 1 }}>
        {children}
      </div>
    </div>
  );
};



export default TimeSlotWrapperWithContextMenu;

